/**
 * Scroll-to-links
 */
jQuery(document).ready(function ($) {
  // Handle Hash in Url on first load
  const hash = document.location.hash.split("#")[1];
  if (hash && isUrlToCurrentPage(document.location.href)) {
    scrollToElementByID(hash, 0);
  }

  // Handle Clicks
  document.body.addEventListener(
    "click",
    function (evt) {
      if (evt.target.nodeName === "A") {
        const href = evt.target.getAttribute("href") || "";
        const hash = href.split("#")[1];
        // noch chekcn ob man auf der richtigen Seite ist
        if (hash && isUrlToCurrentPage(href)) {
          scrollToElementByID(hash);
        }
      }
    },
    false
  );

  /**
   * Is this URL directing to the Path of the current page?
   * @param {string} url
   * @returns boolen
   */
  function isUrlToCurrentPage(url) {
    const base = window.location.protocol + window.location.host;
    const targetPathname = new URL(url, base).pathname;
    return targetPathname === window.location.pathname;
  }

  // animate Page to element with the right ID
  function scrollToElementByID(elementId, speed = 800) {
    // is Hash on same page
    const targetHashElement = document.getElementById(elementId);
    if (targetHashElement) {
      // close navbar if open
      if (luther && luther.navigation) {
        luther.navigation.closeOverlay();
      }
      // scroll to Element
      const scrollTop = $(targetHashElement).offset().top - 50;
      $([document.documentElement, document.body]).animate(
        { scrollTop },
        speed
      );
    }
  }
});
